import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/app/ui/assets/svg/more-data-table.svg'
import _imports_1 from '@/app/ui/assets/svg/refresh-disable.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-3bce8118")

_pushScopeId("data-v-3bce8118")
const _hoisted_1 = {
  ref: "scrollContainer",
  class: "w-full border rounded-lg shadow-sm bg-white"
}
const _hoisted_2 = {
  key: 3,
  ref: "scrollContent",
  class: "min-w-[1200px]"
}
const _hoisted_3 = { class: "w-full border-collapse text-sm" }
const _hoisted_4 = { class: "bg-gray-lp-200 sticky top-0 z-20" }
const _hoisted_5 = { class: "text-12px" }
const _hoisted_6 = { class: "relative" }
const _hoisted_7 = { class: "flex flex-row items-center space-x-2" }
const _hoisted_8 = { class: "font-semibold text-blue-lp-800 text-14px" }
const _hoisted_9 = { class: "text-12px" }
const _hoisted_10 = { class: "text-white text-10px hover:underline flex flex-row items-center justify-center" }
const _hoisted_11 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  alt: "",
  class: "w-4 h-4 ml-1"
}, null, -1)
const _hoisted_12 = { class: "text-12px flex flex-row items-center justify-center py-2 italic text-gray-lp-600" }
const _hoisted_13 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  alt: "",
  class: "w-4 h-4 mr-1"
}, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_BreakdownTableLoading = _resolveComponent("BreakdownTableLoading")!
  const _component_BreakdownTableError = _resolveComponent("BreakdownTableError")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_BreakdownTableLoading, { key: 0 }))
      : (_ctx.error)
        ? (_openBlock(), _createBlock(_component_BreakdownTableError, { key: 1 }))
        : (_ctx.isEmpty)
          ? (_openBlock(), _createBlock(_component_BreakdownTableError, {
              key: 2,
              isEmpty: true
            }))
          : (_openBlock(), _createBlock("div", _hoisted_2, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.tableSections, (section, idx) => {
                return (_openBlock(), _createBlock("div", {
                  key: section.title
                }, [
                  _createVNode("div", {
                    class: "section-scroll overflow-x-auto max-h-100 relative",
                    ref: (el) => _ctx.registerSectionScroll(el)
                  }, [
                    _createVNode("table", _hoisted_3, [
                      _createVNode("thead", _hoisted_4, [
                        _createVNode("tr", null, [
                          _createVNode("th", {
                            class: "sticky z-20 bg-gray-50 p-2 text-center border-b border-t",
                            style: { width: _ctx.freezeCol1Width + 'px', left: '0px' }
                          }, " No ", 4),
                          _createVNode("th", {
                            class: "sticky z-20 bg-gray-50 p-2 text-left border-b border-t",
                            style: {
                    width: _ctx.freezeCol2Width + 'px',
                    left: _ctx.freezeCol1Width + 'px'
                  }
                          }, _toDisplayString(section.title), 5),
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.headers, (h) => {
                            return (_openBlock(), _createBlock("th", {
                              key: h.raw,
                              class: "p-2 text-center whitespace-nowrap border-b border-t bg-gray-50",
                              style: { width: _ctx.dynamicColWidth + 'px' }
                            }, [
                              _createVNode("div", {
                                class: 
                      `flex flex-col items-center ${
                        idx !== 0 ? 'text-gray-50' : ''
                      }`
                    
                              }, [
                                _createVNode("p", _hoisted_5, _toDisplayString(h.label), 1),
                                (idx === 0)
                                  ? (_openBlock(), _createBlock("p", {
                                      key: 0,
                                      class: ["text-10px", _ctx.subHeaderClass(h.raw)]
                                    }, _toDisplayString(_ctx.valueSubHeader(h.raw)), 3))
                                  : _createCommentVNode("", true)
                              ], 2)
                            ], 4))
                          }), 128))
                        ])
                      ]),
                      _createVNode("tbody", _hoisted_6, [
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.visibleData(section), (item, idx) => {
                          return (_openBlock(), _createBlock("tr", {
                            key: section.title + '-' + idx,
                            class: "hover:bg-gray-50"
                          }, [
                            _createVNode("td", {
                              class: "sticky z-10 border-b border-t bg-white p-2 text-center freeze-col-1",
                              style: {
                    left: '0px',
                    '--col1-width': _ctx.freezeCol1Width + 'px'
                  }
                            }, _toDisplayString(idx + 1), 5),
                            _createVNode("td", {
                              class: "sticky z-10 border-b border-t bg-white p-2 text-left freeze-col-2",
                              style: {
                    left: _ctx.freezeCol1Width + 'px',
                    '--col2-width': _ctx.freezeCol2Width + 'px'
                  }
                            }, [
                              _createVNode("div", _hoisted_7, [
                                _createVNode("div", _hoisted_8, _toDisplayString(item.name), 1),
                                _createVNode("div", _hoisted_9, _toDisplayString(_ctx.valueBasedOnType(item.total)), 1),
                                (item.percentageChange !== 0)
                                  ? (_openBlock(), _createBlock("div", {
                                      key: 0,
                                      class: ["text-8px rounded-lg px-1 flex flex-row space-x-1 items-center", _ctx.chipsClass(item.percentageChange)]
                                    }, [
                                      _createVNode("img", {
                                        src: 
                          item.percentageChange > 0
                            ? require('@/app/ui/assets/svg/arrow-up-green.svg')
                            : require('@/app/ui/assets/svg/arrow-down-red.svg')
                        ,
                                        alt: "",
                                        class: "w-1.5 h-1.5"
                                      }, null, 8, ["src"]),
                                      _createTextVNode(" " + _toDisplayString(item.percentageChange) + "% ", 1)
                                    ], 2))
                                  : _createCommentVNode("", true)
                              ])
                            ], 4),
                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.headers, (h) => {
                              return (_openBlock(), _createBlock("td", {
                                key: h.raw,
                                class: ["p-2 text-center whitespace-nowrap border-l border-r border-gray-lp-500", _ctx.rowClass(item.data?.[h.raw]?.percentageChange)],
                                style: {
                    width: _ctx.dynamicColWidth + 'px',
                    minWidth: _ctx.dynamicColWidth + 'px'
                  }
                              }, _toDisplayString(_ctx.valueBasedOnType(item.data?.[h.raw]?.value ?? 0)), 7))
                            }), 128))
                          ]))
                        }), 128))
                      ])
                    ]),
                    (section.data.length > _ctx.visibleCounts[section.title])
                      ? (_openBlock(), _createBlock("div", {
                          key: 0,
                          class: "text-center py-1 bg-black-lp-300 sticky bottom-4 left-20 w-40 z-10 rounded-2xl cursor-pointer",
                          onClick: ($event: any) => (_ctx.loadMore(section.title))
                        }, [
                          _createVNode("div", _hoisted_10, [
                            _createTextVNode(_toDisplayString(_ctx.$t("dashboard.breakdownTable.scrollMore")) + " ", 1),
                            _hoisted_11
                          ])
                        ], 8, ["onClick"]))
                      : _createCommentVNode("", true)
                  ], 512)
                ]))
              }), 128)),
              _createVNode("div", _hoisted_12, [
                _hoisted_13,
                _createVNode("p", null, _toDisplayString(_ctx.$t("dashboard.breakdownTable.lastSync")) + " " + _toDisplayString(_ctx.lastSyncAt), 1)
              ])
            ], 512))
  ], 512))
})